import React, { useState, useEffect } from 'react';
import Header from '../../components/global/Header';
import { Box, Button, Paper, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import client from '../../API/client';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ManageRecruiter = () => {
  const [recruiterdata, setRecruiterData] = useState([]);
  const [ids, setIds] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const deleteUsers = async () => {
    // console.log(ids);
    const payload = { ids };
    await client.post(`/admin/delete-recruiter`, payload).then((res) => {
      if (res.status === 200) {
        toast.success('Recruiter Deleted Sucessfully', {
          position: toast.POSITION.TOP_CENTER,
        });
        getData();
      } else {
        toast.error('OOps!! Something went wrong ', {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    });
  };

  const recRowId = (recruiterdata) => recruiterdata.recruiter_id;

  const getData = async () => {
    await client
      .get('/admin/get-recruiter-details', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(async (res) => {
        console.log(res.data);
        setRecruiterData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const reccolumns = [
    { field: 'designer_id', headerName: 'ID', hide: true },

    {
      field: 'r_username',
      headerName: 'User Name',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'r_fullname',
      headerName: 'Full Name',
      flex: 1,
    },
    {
      field: 'r_email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'company_name',
      headerName: 'Company Name',
      headerAlign: 'left',
      flex: 1,
    },
  ];

  return (
    <>
      <Box m="20px">
      <ToastContainer/>
        <Header
          title="Users Information Page"
          subtitle={'Users Information '}
        />
        {/* <Box > */}
        <Button
          onClick={() => deleteUsers()}
          variant="contained"
          sx={{ marginTop: '20px', marginLeft: '5px', letterSpacing: 2 }}>
          <DeleteIcon sx={{ marginRight: '5px' }} />
          Delete
        </Button>
        {/* </Box> */}

        <Paper elevation={5}>
          <Box
            m="10px 0 0 0"
            height="75vh"
            sx={{
              '& .MuiDataGrid-root': {
                border: '1px solid grey',
              },
              '& .MuiDataGrid-cell': {
                color: 'black',
                borderBottom: '1px solid gray',
              },
              '& .name-column--cell': {
                color: 'black',
              },
              '& .MuiDataGrid-columnHeaders': {
                color: 'black',
                // backgroundColor:"#d5fff1",
                borderBottom: 'none',
              },
              '& .MuiDataGrid-virtualScroller': {
                backgroundColor: 'white',
                //   color:"white",
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: 'none',
                // backgroundColor:"#d5fff1",
              },
              '& .MuiCheckbox-root': {
                color: `${'black'} !important`,
              },
            }}>
            <DataGrid
              checkboxSelection
              rows={recruiterdata}
              getRowId={recRowId}
              disableSelectionOnClick
              columns={reccolumns}
              onSelectionModelChange={(data) => {
                setIds(data);
              }}
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
};